module.exports = __webpack_public_path__ + "assets/Haut_Schleimhaut.809b493e.png";